<script setup>
defineProps({
  closeToast: {
    type: Function,
    default: () => {
      return null
    }
  },
  toastProps: {
    type: Object,
    default: () => {
      return null
    }
  }
})
</script>

<template>
  <div class="newVersionToast">
    <div class="newVersionInfo">
      {{ toastProps.data.msg }}<br>
      {{ toastProps.data.msgBis }}
    </div>
    <a href="#" @click="($event) => { closeToast && closeToast($event) }">{{ toastProps.data.refreshButton }}</a>
  </div>
</template>

